import React, { useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useWindowDimension from '../../../hooks/WindowDimension';
import NavbarSindicoDesktop from './NavbarSindicoDesktop/NavbarSindicoDesktop';
import NavbarSindicoMobile from './NavbarSindicoMobile/NavbarSindicoMobile';

import { ContextSindico } from '../../../services/sindico';
const NavbarSindico = () => {
  const dimensions = useWindowDimension();
  const history = useHistory();
  const location = useLocation();
  const { logoutSindico, handleClickDocuments } = useContext(ContextSindico);

  function goToHome() {
    history.push('/sindico/inicio/');
  }

  function goToSolicitations() {
    history.push('/sindico/solicitacoes-abertas/');
  }

  const isMobile = dimensions.winWidth < 768;

  return isMobile ? (
    <NavbarSindicoMobile
      goToHome={goToHome}
      goToSolicitations={goToSolicitations}
      goToDocuments={handleClickDocuments}
      handleLogoutSindico={logoutSindico}
      activeRoute={location.pathname}
    />
  ) : (
    <NavbarSindicoDesktop
      goToHome={goToHome}
      goToSolicitations={goToSolicitations}
      goToDocuments={handleClickDocuments}
      handleLogoutSindico={logoutSindico}
      activeRoute={location.pathname}
    />
  );
};

export default NavbarSindico;
